import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scrollToTopInstant } from '../../utils/scrollToTop';

function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if (pathname !== '/carrito') {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      return undefined;
    }

    const previousRestoration = window.history.scrollRestoration;
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    scrollToTopInstant();
    const frame = window.requestAnimationFrame(scrollToTopInstant);
    const timeouts = [0, 50, 300, 600].map((ms) => (
      window.setTimeout(scrollToTopInstant, ms)
    ));

    return () => {
      window.cancelAnimationFrame(frame);
      timeouts.forEach((id) => window.clearTimeout(id));
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = previousRestoration || 'auto';
      }
    };
  }, [pathname]);

  return null;
}

export default ScrollToTop;
